import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BaseUrlService {
  public _userUrl: string = '';

  public _authUrl:string = ''

  constructor() { }
}

